import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export const initSpotlightScript = () => {
  const sections = document.querySelectorAll('.spotlight');

  sections.forEach((section) => {
    const slides = section.querySelectorAll('.spotlight__slide');

    if (slides.length <= 1) {
      return;
    }
    slides.forEach((slide) => {
      slide.classList.remove('xl:max-w-[1296px]');
    });

    const wrapper = section.querySelector('.spotlight__wrapper');
    wrapper?.classList.remove('gap-5', 'lg:gap-10');

    new Swiper('.spotlight__container', {
      slidesPerView: 'auto',
      loop: false,
      slidesPerGroup: 1,
      freeMode: true,
      navigation: {
        nextEl: '.spotlight__button--next',
        prevEl: '.spotlight__button--prev',
        disabledClass: 'pointer-events-none opacity-0',
      },
      breakpoints: {
        375: { slidesPerView: 1.156, spaceBetween: 20 },
        768: { slidesPerView: 1.8, spaceBetween: 20 },
        1024: { slidesPerView: 1.1, spaceBetween: 20 },
        1536: { slidesPerView: 1.083827, spaceBetween: 40 },
      },
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        const active = document.activeElement;
        if (active && active.tagName.toLowerCase() === 'a') {
          active.dispatchEvent(new MouseEvent('click', { bubbles: true }));
        }
      }
    });
  });
};
